module.exports = __webpack_public_path__ + "img/Jasper - Shrug.46bcb81c.png";